import { render, staticRenderFns } from "./affair.vue?vue&type=template&id=de18afca&scoped=true&"
import script from "./affair.vue?vue&type=script&lang=js&"
export * from "./affair.vue?vue&type=script&lang=js&"
import style0 from "./affair.vue?vue&type=style&index=0&id=de18afca&scoped=true&lang=less&"
import style1 from "./affair.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de18afca",
  null
  
)

export default component.exports